export default __webpack_public_path__ + "static/logo7-fca98d873ab362ef360cba5d4d10a7e6.webp";